/**
 * Die Zeitzone eines Objekts als Wort („Mitteleuropäische Zeit“) statt als technische Kennung
 * („Europe/Berlin“). Kennt die Laufzeit die Zone nicht, bleibt die Kennung sichtbar – lieber
 * technisch als gar nicht.
 */
export function timeZoneWord(timezone: string): string {
  try {
    const name = new Intl.DateTimeFormat('de-DE', {
      timeZone: timezone,
      timeZoneName: 'longGeneric',
    })
      .formatToParts(new Date())
      .find((part) => part.type === 'timeZoneName')?.value;
    return name && !name.startsWith('GMT') ? name : timezone;
  } catch {
    return timezone;
  }
}
